import { render } from "./Collections.vue?vue&type=template&id=5b540b2c"
import script from "./Collections.vue?vue&type=script&lang=js"
export * from "./Collections.vue?vue&type=script&lang=js"

import exportComponent from "/Users/samuelquaresma/Documents/Dev/DAF/app-capacitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__